import {makeAutoObservable} from 'mobx';
import {MAX_QUANTITY_INPUT, MIN_QUANTITY_INPUT, RootWidgetComponentIds} from '../../../config/constants';
import {RootStore} from '../../../stores/RootStore';
import {getQuantityValidation} from '../../validator-service/getQuantityValidation';

export const bindQuantityWidgetProps = (rootStore: RootStore) => {
  const {
    $state,
    controllerParams: {$bind},
  } = rootStore;

  const quantityStore = makeAutoObservable({
    get validation() {
      return getQuantityValidation(rootStore);
    },
    get min() {
      return $state.minQuantity ?? MIN_QUANTITY_INPUT;
    },
    get max() {
      return $state.maxQuantity ?? MAX_QUANTITY_INPUT;
    },
  });
  return $bind(RootWidgetComponentIds.Quantity, {
    max: () => quantityStore.max,
    min: () => quantityStore.min,
    value: () => $state.quantityInput,
    isError: () => quantityStore.validation.isError,
    errorMessage: () => quantityStore.validation.errorMessage,
  });
};
